export default "/images/externalLinkIcon.svg?d1529b38ebe6e223926a783ad5026690";